import React from 'react';
import get from 'lodash/get';

import Block from '@views/components/block/Block';
import Product from '@views/components/product/Product';

import Gallery from './components/gallery';
import Info from './components/info';

import useShopeeVideo from '@views/modules/product/hooks/use-shopee-video';
import { absoluteUrl } from '@lib/helpers';

function useGallery({ shopeeId, defaultData, video }) {
  const { data } = useShopeeVideo(shopeeId);

  let galleries = defaultData;
  if (video) {
    galleries = [
      {
        id: 'youtube',
        type: 'youtube',
        value: video,
        thumbnail: absoluteUrl('/assets/icon/play.svg'),
      },
      ...galleries,
    ];
  } else if (shopeeId && !!get(data, 'shopeeItem.videoUrl')) {
    galleries = [
      {
        id: 'shopee',
        type: 'shopee',
        value: get(data, 'shopeeItem.videoUrl'),
        thumbnail: absoluteUrl('/assets/icon/play.svg'),
      },
      ...galleries,
    ];
  }

  return galleries;
}

export const ProductContent = ({ data }) => {
  const id = get(data, 'product.id');
  const name = get(data, 'product.name');
  const price = get(data, 'product.price', 0);
  const listPrice = parseInt(get(data, 'product.attributes.listPrice', 0));
  const quantityAvailable = get(data, 'product.quantity', 0);
  const isContactProduct = get(data, 'product.isContactProduct', false);
  const video = get(data, 'product.video', false);
  const gallery = get(data, 'product.attributes.galleries', []);
  const shopeeId = get(data, 'product.shopeeId', []);
  const brand = get(data, 'product.attributes.brand');

  const galleries = useGallery({
    shopeeId,
    defaultData: gallery,
    video: video,
  });

  let ratingValue = null;
  const ratingCount = get(data, 'summary.ratingCount', []);
  let starCount = 0;
  let starSum = 0;
  if (Array.isArray(ratingCount)) {
    ratingCount.forEach((value, index) => {
      starCount += value;
      starSum += value * (index + 1);
    });

    if (starCount > 0) {
      ratingValue = (starSum / starCount).toFixed(2);
    }
  }

  return (
    <Block isSection>
      <Product standard>
        <Product.Content>
          <Gallery data={galleries} />
          <Product.Body>
            <Info
              id={parseInt(id)}
              name={name}
              price={price}
              listPrice={listPrice}
              quantityAvailable={quantityAvailable}
              isContactProduct={isContactProduct}
              rating={ratingValue}
              brand={brand}
            />
          </Product.Body>
        </Product.Content>
      </Product>
    </Block>
  );
};

export default ProductContent;
